import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_974_6145",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_974_6145)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.4615 20.5L3.5 15.5385V8.4615L8.4615 3.5H15.5385L20.5 8.4615V15.5385L15.5385 20.5H8.4615ZM9.15 15.9038L12 13.0538L14.85 15.9038L15.9038 14.85L13.0538 12L15.9038 9.15L14.85 8.09625L12 10.9462L9.15 8.09625L8.09625 9.15L10.9463 12L8.09625 14.85L9.15 15.9038Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDanger;
